import { render } from "./ResolveYoutubeChannel.vue?vue&type=template&id=4740e974&scoped=true"
import script from "./ResolveYoutubeChannel.vue?vue&type=script&lang=js"
export * from "./ResolveYoutubeChannel.vue?vue&type=script&lang=js"

import "./ResolveYoutubeChannel.vue?vue&type=style&index=0&id=4740e974&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4740e974"]])

export default __exports__